export default __webpack_public_path__ + "d6eeb9d1693fec1246b08fdc11396938.png";